// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"fba94c88","750":"9292a8be"}[chunkId] + ".chunk.js";
};